import type { ScoreEdition } from '@/music/score/edition';

/**
 * The link that opens THIS tune in a given reading, for the horn player's
 * phone. The workbench URL already names the tune (`?tune=…&by=…`, see
 * `useTuneUrl`); `read` says which book to open it in. The C book is the
 * parameter's ABSENCE, so every link the app ever produced still means
 * exactly what it meant.
 */
export function readingLinkUrl(href: string, edition: ScoreEdition): string {
  const url = new URL(href);
  if (edition === 'c') url.searchParams.delete('read');
  else url.searchParams.set('read', edition);
  return url.toString();
}
